import {ValueObject} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'

export class WarrantyVehiclesValueObject extends ValueObject {
  #id
  #name
  #months

  constructor({id, name, months}) {
    super()
    this.#id = id
    this.#name = name
    this.#months = months
  }

  static createFromListingApi({warranty}) {
    return new WarrantyVehiclesValueObject({
      id: warranty.id ? IdSharedValueObject.createFromPrimitives({id: warranty.id}) : {},
      name: warranty.literal,
      months: warranty.months
    })
  }

  get id() {
    return this.#id.value
  }

  get name() {
    return this.#name
  }

  get months() {
    return this.#months
  }

  get value() {
    return {
      id: this.id,
      name: this.name,
      months: this.months
    }
  }
}
